import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { applyImportantStyles } from '../../../lib';

import './Button.css';

const Button = forwardRef(
    (
        {
            className,
            children,
            icon,
            iconSize,
            disabled,
            isWorking,
            onClick,
            size,
            color,
            styles,
            title,
            width,
            alignItems,
        },
        ref
    ) => {
        width = typeof width === 'string' ? width : width + 'px';

        const handleClick = (event) => {
            if (!disabled && !isWorking) {
                onClick(event);
            }
        };
        return (
            <button
                onClick={handleClick}
                className={`ab-button ${className}`}
                style={{ fontSize: size + 'px', color, width, alignItems }}
                title={title}
                // TODO: NOT SURE ABOUT THIS
                ref={(el) => {
                    applyImportantStyles(el, {
                        ...styles,
                    });
                }}
            >
                {!isWorking && icon}
                {/* TODO: ADD SPACE BETWEEN ICON AND TEXT */}
                {children}
            </button>
        );
    }
);

Button.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    iconSize: PropTypes.number,
    disabled: PropTypes.bool,
    isWorking: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.number,
    styles: PropTypes.object,
    color: PropTypes.string,
    title: PropTypes.string,
    alignItems: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Button.defaultProps = {
    className: '',
    children: undefined,
    icon: undefined,
    iconSize: 18,
    disabled: false,
    isWorking: false,
    onClick: () => {},
    size: 14,
    color: '#323b43',
};

Button.displayName = 'Button';

export default Button;
